<app-layout-container (tabClick)="onTabClick($event)" [navbarItems]="navbar()" [tabbar]="tabbar()" [useCard]="false">
  @let portfolioIdValue = portfolioId();
  @if (hasClimateRiskLicense() && portfolioIdValue) {
    <cfp-link
      headerBottomButtons
      class="order-3"
      [classes]="'d-flex align-items-center'"
      [buttonStyle]="'primary'"
      [route]="`/climate-risk/${portfolioIdValue}`"
      >{{ 'nav.climateRisk' | translate }}<cfp-icon [icon]="'circle-arrow-right'" class="ms-2" [iconType]="'solid'" [iconSize]="'large'"
    /></cfp-link>
  }
  <cfp-portfolio-header
    class="d-print-none"
    [portfolio]="portfolio()"
    [labelGroup]="labelGroup()"
    [labelGroups]="labelGroups() ?? []"
    (clearFilters)="clearFilters($event)"
    (toggleM2)="toggleM2()"
    [(showM2)]="showM2"
    [filtersButtonDisabled]="isShowingFilters()"
    [activeFiltersCount]="filterBadges().length"
    (showFiltersSidePanel)="showFilters()"
    (showAddBuildingFlow)="showAddBuildingModal($event)"
  />

  <cfp-page-section [section]="'CONTENT_TOP'" />
  <cfp-page-section-portfolio [portfolioId]="portfolioIdValue" [section]="'PORTFOLIO_TOP'" />

  @if (filterBadges().length > 0) {
    <div class="mb-4 d-print-none row g-2">
      @for (item of filterBadges(); let index = $index; track item.value) {
        <cfp-filter-badge (clicked)="removeFilterBadge(index)" class="col-auto" [label]="item.display" />
      }
    </div>
  }

  <router-outlet [routerOutletData]="portfolioLayoutData()" />
</app-layout-container>
